enum SegmentoRfm {
  Indeterminado = 'indeterminado',
  Campeoes = 'campeoes',
  AtivosValiosos = 'ativosValiosos',
  PromessasSemPagamento = 'promessasSemPagamento',
  EmRisco = 'emRisco',
  Dormentes = 'dormentes',
  SemDividaParaNegociar = 'semDividaParaNegociar',
  NovoEmRisco = 'novoEmRisco',
}

const segmentoRfmPorIndice: Record<string, SegmentoRfm> = {
  '0': SegmentoRfm.Indeterminado,
  '1': SegmentoRfm.Campeoes,
  '2': SegmentoRfm.AtivosValiosos,
  '3': SegmentoRfm.PromessasSemPagamento,
  '4': SegmentoRfm.EmRisco,
  '5': SegmentoRfm.Dormentes,
  '6': SegmentoRfm.SemDividaParaNegociar,
  '7': SegmentoRfm.NovoEmRisco,
};

export function segmentoRfmFromString(valor: string | undefined): SegmentoRfm {
  if (!valor) return SegmentoRfm.Indeterminado;
  return segmentoRfmPorIndice[valor] ?? SegmentoRfm.Indeterminado;
}

export default SegmentoRfm;
